import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    title: {},

    appBar: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: theme.spacing(2)
    },
    filters: {
      display: 'flex',
      //marginTop: theme.spacing(2),
      zIndex: 10
    },
    filter: {
      marginRight: theme.spacing(2)
    },

    customFilter: {
      display: 'block',
      marginLeft: '3.5%'
    }
  });
